module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"네오-트라이브2020 온라인 글꼴 전시 아카이브 사이트","short_name":"네오-트라이브2020","start_url":"/","background_color":"#4400CC","theme_color":"#4400CC","display":"minimal-ui","icon":"src/images/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"8183829bab00549a0b3deeb3571cbc16"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
